import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = '/tramites/bitacoras/';
export const baseURIB = '/bitacora/bitacora-trazabilidad/';

/**
 * GET Bitacoras
 * @param {Object} params
 * @returns {Promise<Array<object>>}
 */
export const getBitacoras = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};
/**
 * GET Bitacoras Padrones
 * @param {Object} params - filtros para la búsqueda
 * @returns {Promise<Array<object>>}
 */
export const getBitacorasPadrones = async (params) => {
  try {
    const response = await API.get(baseURIB, { params });
    return response.data || [];
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Bitacora
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getBitacora = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Bitacora
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postBitacora = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Bitacora
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchBitacora = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Bitacora
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteBitacora = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 *
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getBitacoraPorPadron = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}/por-padron`);
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};
